import { FC } from 'react';
import { Modal } from 'react-bootstrap';

interface UserTableModalProps {
    user: any;
    onClose: () => void;
    show: boolean;
}

export const AssignVehicleRequirementPopUp: FC<UserTableModalProps> = ({ user, onClose, show }) => {
    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_user'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            centered
            size="lg"
        >
            <div className="modal-content">
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}> X
                    </div>
                </div>

                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                    <div className="text-center mb-13">
                        <h1 className="mb-3">Partner Details</h1>
                    </div>

                    {/* Supply Partner Details Table */}
                    <div className="mb-8">
                        <h3 className="fw-bold mb-3">Pick up Information</h3>
                        <div className="table-responsive">
                            <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                                <thead>
                                    <tr className="fw-bold text-muted bg-light">
                                        <th className="min-w-150px ps-4" style={{ background: "#BFD7ED", color: "black" }}>Supply Partner Name</th>
                                        <th className="min-w-250px" style={{ background: "#BFD7ED", color: "black" }}>Address</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="ps-4">
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {user?.companyName || 'N/A'}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {user?.supplyPartner?.address || 'N/A'}
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Recycler Details Table */}



                    <div className="mb-8">
                        <h3 className="fw-bold mb-3">Delivery Information</h3>
                        <div className="table-responsive">
                            <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                                <thead>
                                    <tr className="fw-bold text-muted bg-light">
                                        <th className="min-w-150px ps-4" style={{ background: "#BFD7ED", color: "black" }}>Recycler Name</th>
                                        <th className="min-w-250px" style={{ background: "#BFD7ED", color: "black" }}>Address</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="ps-4">
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {user?.recyclerDetails.name || 'N/A'}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {user?.deliveryAddress || 'N/A'}
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>



                    <div className="mb-8">
                        <div className="table-responsive">
                            <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                                <thead>
                                    <tr className="fw-bold text-muted bg-light">
                                        <th className="min-w-150px ps-4" style={{ background: "#BFD7ED", color: "black" }}>Quantity (Kg)</th>
                                        <th className="min-w-250px" style={{ background: "#BFD7ED", color: "black" }}>Packaginng</th>
                                        <th className="min-w-250px" style={{ background: "#BFD7ED", color: "black" }}>Loading Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="ps-4">
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {'N/A'}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {'N/A'}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="text-dark fw-semibold d-block fs-6">
                                                {user.dispatchDate ? (() => {
                                                    const date = new Date(user.dispatchDate);
                                                    if (isNaN(date.getTime())) return 'N/A';
                                                    const day = date.getDate().toString().padStart(2, '0');
                                                    const month = (date.getMonth() + 1).toString().padStart(2, '0');
                                                    const year = date.getFullYear().toString().slice(-2);
                                                    return `${day}/${month}/${year}`;
                                                })() : 'N/A'}
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>







                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={onClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};